import React, { useContext, useEffect, useState } from "react";
import { Card, Form, Input, Menu, Modal, Radio, Switch, Table, Tooltip, Typography, Upload } from "antd";
import "./../../../styles/configuration.css";
import CustomConfiguration from "./CustomConfiguration";
import TDSConfiguration from "./tdsConfiguration";

const Configuration = () => {

    const [selectedMenu, setSelectedMenu] = useState("customConfiguration");

    const renderContent = () => {
        switch (selectedMenu) {
            case "customConfiguration":
                return <CustomConfiguration />;
            case "tds":
                return <TDSConfiguration />;
            default:
                return null;
        }
    };

    return (
        <div style={{ height: "100dvh", width: "100%" }}>
            <div className="flex">
                <div style={{ height: "90dvh", width: "15%", marginRight: "5px", backgroundColor:"white" }}>
                    <div className="menu-container">
                        <div style={{ paddingLeft: "10px" }}
                            className={`menu-item ${selectedMenu === "customConfiguration" ? "active" : ""}`}
                            onClick={() => setSelectedMenu("customConfiguration")}
                        >
                            Salary Configuration
                        </div>
                        <div style={{ paddingLeft: "10px" }}
                            className={`menu-item ${selectedMenu === "tds" ? "active" : ""}`}
                            onClick={() => setSelectedMenu("tds")}
                        >
                            Tds Configuration
                        </div>
                        {/* <div style={{ paddingLeft: "10px" }}
                            className={`menu-item ${selectedMenu === "password" ? "active" : ""}`}
                            onClick={() => setSelectedMenu("password")}
                        >
                            Password
                        </div> */}
                    </div>
                </div>
                <Card style={{ height: "90dvh", width: "85%", marginRight: "5px" }}>
                    {renderContent()}
                </Card>
            </div>
        </div>
    );
}

export default Configuration;